import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";
import { QueryBuilderState } from "../../types/AppState";
import { apiFetchFields } from "./queryBuilderApi";
import {apiFetchQueryMetaData} from "../../actions/queryBuilderApi";

const initialState: QueryBuilderState = {
    fields: undefined,
    queryMetaData: undefined,
}

export const fetchFields = createAsyncThunk(
    'queryBuilderSlice/fetchFields',
    async () => {
        return await apiFetchFields()
    }
)

export const fetchQueryMetaData = createAsyncThunk(
    'queryBuilder/fetchQueryMetaData',
    async (queryId: string) => {
        return apiFetchQueryMetaData(queryId)
    }
)

export const queryBuilderSlice = createSlice({
    name: 'queryBuilderSlice',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchFields.pending, (state, action) => {
            state.fields = undefined
        })
        builder.addCase(fetchFields.fulfilled, (state, action) => {
            state.fields = {}
            action.payload.forEach(obj => state.fields![obj.code] = obj)
        })
    }
})

export const selectFields = (state: RootState) => state.queryBuilder.fields

export default queryBuilderSlice.reducer